import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useContentEmbed from 'hooks/useContentEmbed';

// TODO FIXME after migrating to class-based component we could get rid
// of this component and use the hooks directly in the index
// For more documentation on this see docs/article-content-embeds.md
const ContentScriptEmbedHandler = ({ contentScripts }) => {
  const { addScriptEmbeds, removeScriptEmbeds } = useContentEmbed();

  useEffect(() => {
    addScriptEmbeds(contentScripts);
    return () => removeScriptEmbeds(contentScripts);
  }, [contentScripts]);

  return null;
};

ContentScriptEmbedHandler.propTypes = {
  contentScripts: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ContentScriptEmbedHandler;
